/**
 * @description Update agreement document (Machine just now.)
 */
export default class FormDocuments {
    /**
     * @description Convert base64 to blob
     * @param {*} base64
     * @param {*} mimeType
     * @returns {Blob}
     */
    base64ToBlob(base64, mimeType) {
        const byteCharacters = atob(base64);
        const byteArray = new Uint8Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteArray[i] = byteCharacters.charCodeAt(i);
        }
        return new Blob([byteArray], { type: mimeType });
    }

    /**
     * @description Update agreement document
     * @returns void
     */
    updateAgreementDocument() {
        const documentLink = document.querySelector('#reviewAgreementDocuments');
        const pdfDocumentName = document.querySelector('#pdfDocumentName');
        const pdfDocument = document.querySelector('#pdfDocument');

        if (document.querySelector('#agreementFile').files?.length > 0) {
            const input = document.querySelector('#agreementFile');
            const file = input.files[0];
            const url = URL.createObjectURL(file);

            documentLink.textContent = file.name;
            documentLink.href = url;
            pdfDocumentName.value = file.name;
            pdfDocument.value = url;
        } else if (pdfDocumentName?.value && pdfDocument?.value) {
            // Convert base64 to blob URL for document recieved from M3
            const base64Data = pdfDocument.value;
            const blob = this.base64ToBlob(base64Data, 'application/pdf');
            const url = URL.createObjectURL(blob);

            documentLink.textContent = pdfDocumentName.value;
            documentLink.href = url;
        }
    }
}
